import api_base from '@/api/base';

export interface DashboardStats {
    upcoming_sessions: {
        count: number;
        tribunal_count: number;
        office_count: number;
        upcoming_thisMonth: number;
        next_session_date: string | null;
        trend: {
            value: number;
            label: string;
            direction: 'up' | 'down' | 'neutral';
        };
    };
    active_folders: {
        count: number;
        new_this_week: number;
    };
}

export const get_dashboard_stats = async (): Promise<DashboardStats> => {
    const response = await api_base.get('/api/v1/dashboard/');
    return response.data;
};
